import { render, staticRenderFns } from "./DropPlaceholder.vue?vue&type=template&id=339705ce&"
import script from "./DropPlaceholder.vue?vue&type=script&lang=js&"
export * from "./DropPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports